module.exports = __webpack_public_path__ + "img/Triangle.bcc39e2f.svg";